

function Layout({ children }) {
    return (
        <div className='flex justify-center p-4'>
            {children}
        </div>
    );
}

export default Layout;
